import React from "react";
import { useNavigate } from "react-router-dom";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import { useEnabledFeatureFlag } from "../../../common/feature-flagging/FeatureFlagProvider";
import FeatureFlags from "../../../common/feature-flagging/FeatureFlags";

const EmployeeImportJobTableEmptyStateContainer: React.FC = () => {
  const navigate = useNavigate();

  const flagEmployeeImporterToolsV2 = useEnabledFeatureFlag(
    FeatureFlags.EMPLOYEE_IMPORTER_TOOLS_V2
  );
  return (
    <EmptyStateContainer
      title="You have no employee import jobs"
      description="Upload a employee import job to create and update your employees data."
      button={{
        onClick: () => {
          if(flagEmployeeImporterToolsV2){
            navigate("/employee-data-importer-v2")

          }else{
            navigate({
              pathname: "/employee-data-importer",
            });
          }
        },
        title: "Upload Employee Import",
      }}
    />
  );
};

export default EmployeeImportJobTableEmptyStateContainer;
